export default <T>(arg: T): arg is Exclude<T, null> => (
  arg !== null
);
